export const SET_SHORTER_TUTORIAL = "SET_SHORTER_TUTORIAL";
